import React, { useEffect, useRef, useState } from 'react';
import useWindowViewport from "../hooks/useWindowViewport";
import useOutsideClick from "../hooks/useOutsideClick";
import useNearBottom from "../hooks/useNearBottom";

const phoneContacts = [
    { label: "Soporte", number: "+525632018306", description: "Resuelve tus dudas" },
];

const WhatsappSupport = () => {
    const { windowWidth } = useWindowViewport();
    const [areOpenPhones, setAreOpenPhones] = useState(false);
    const btnSupportRef = useRef(null);
    const [bottomHeight, setBottomHeight] = useState(50);
    const nearBottom = useNearBottom(bottomHeight);

    useOutsideClick({
        ref: btnSupportRef,
        handler: () => setAreOpenPhones(false),
    });

    const handleOpenPhones = () => setAreOpenPhones(prev => !prev);
    const handleOpenLink = (phone) => {
        if (phone) {
            window.open(`https://wa.me/${phone}`, '_blank');
            handleOpenPhones()
        }
    };

    useEffect(() => {
        setBottomHeight(windowWidth < 568 ? 100 : 50);
    }, [windowWidth]);

    const btnWrapperClass = `whatsapp-support ${nearBottom ? "bottom-btn-support" : ""}`;
    const openPhonesClass = areOpenPhones ? "show" : "hide";
    const activeClass = areOpenPhones ? "active" : "";
    const rippleClass = areOpenPhones ? "" : "ripple-effect";

    return (
        <div className={btnWrapperClass} ref={btnSupportRef}>
            <div className={`whatsapp-support__btn-phones ${openPhonesClass}`}>
                {phoneContacts.map(({ label, number,description }) => (
                    <div key={number} className="whatsapp-support__btn-phones__item">
                        <p>{label} <span>{description}</span></p>
                        <button
                            type="button"
                            className="btn-whatsapp"
                            onClick={() => handleOpenLink(number)}
                            aria-label={`Contactar por WhatsApp a ${label}`}
                        >
                            <i className="fab fa-whatsapp"></i>
                        </button>
                    </div>
                ))}
            </div>

            <button
                type="button"
                className={`btn-support ${activeClass}`}
                onClick={handleOpenPhones}
                aria-label="Abrir menú de soporte de WhatsApp"
                aria-expanded={areOpenPhones}
            >
                <span className={rippleClass}></span>
                <i className={areOpenPhones ? "fas fa-times" : "fa fa-headset"}></i>
            </button>
        </div>
    );
};

export default WhatsappSupport;
